//https://strapi.codesour.dev/contacts?id_campaign.name=Consenso_Alessi
import { useEffect, useState } from "react";
import { Button, Col, Row, Table, Popconfirm } from "antd";
import { service } from "../../services/service";

import {
  DeleteOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
function PageForEmbbed() {
  const [tableValue, setTableValue] = useState([]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Surname",
      dataIndex: "surname",
      key: "surname",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Agency",
      dataIndex: "agency",
      key: "agency",
    },
    {
      title: "consenso dati",
      dataIndex: "checkbox_1",
      key: "checkbox_1",
      render: (a) => {
        if (a === true) {
          return <CheckOutlined style={{ color: "green" }} />;
        } else {
          return <CloseOutlined style={{ color: "red" }} />;
        }
      },
    },
    {
      title: "consenso commerciali",
      dataIndex: "checkbox_2",
      key: "checkbox_2",
      render: (a) => {
        if (a === true) {
          return <CheckOutlined style={{ color: "green" }} />;
        } else {
          return <CloseOutlined style={{ color: "red" }} />;
        }
      },
    },
    {
      title: "consenso contattato",
      dataIndex: "checkbox_3",
      key: "checkbox_3",
      render: (a) => {
        if (a === true) {
          return <CheckOutlined style={{ color: "green" }} />;
        } else {
          return <CloseOutlined style={{ color: "red" }} />;
        }
      },
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (a, b, c) => (
        <Popconfirm
          title="Delete Lead"
          description="Are you sure to delete this Lead?"
          onConfirm={() => service.deleteLead(a.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button
            type="deafult"
            style={{ color: "red" }}
            icon={<DeleteOutlined />}
          />
        </Popconfirm>
      ),
    },
  ];

  useEffect(() => {
    getTable();
  }, []);

  function getTable() {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    fetch(
      `https://strapi.codesour.dev/leads?id_campaign.name=Consenso_Alessi`,
      requestOptions
    )
      .then((res) => res.json())
      .then((res) => {
        setTableValue(res);
      })
      .catch((error) => {
        console.error("Errore durante il recupero dei dati:", error);
      });
  }

  return (
    <Row>
      <Col span={24}>
        <Table
          columns={columns}
          dataSource={tableValue}
          pagination={{ defaultCurrent: 1 }}
        />
      </Col>
    </Row>
  );
}
export default PageForEmbbed;
